import React, { useRef } from "react";
import AFrameContainer from "./components/AFrameContainer";
import "./App.scss";

import useCameraRecorder from "./hooks/useCameraRecorder";
import { shareCurrent as shareMedia } from "./utils/share";

function App() {
  const webglCanvasRef = useRef(null);
  const apiRef = useRef(null);
  const reviewVideoRef = useRef(null);
  const containerRef = useRef(null);

  const {
    recording, arming, videoURL, photoURL, posterURL,
    showPlayOverlay, transcoding, shareMime,
    onRecordPointerDown, onRecordPointerUpOrCancel,
     retake, flipCamera, playWithSound, setMicStream,
  } = useCameraRecorder({ webglCanvasRef, containerRef, reviewVideoRef, apiRef });

  const inPreview = Boolean(videoURL || photoURL);

  const onCanvasReady = (canvas) => {
    if (canvas instanceof HTMLCanvasElement) webglCanvasRef.current = canvas;
  };
  const onApi = (api) => { apiRef.current = api; };

  const onShare = async () => {
    await shareMedia({ photoURL, videoURL, shareMime });
  };


  return (
    <div className="app-container">
      <div className="video-container front" ref={containerRef}>
        <AFrameContainer
          onCanvasReady={onCanvasReady}
          onApi={onApi}
          onArStarted={() => {}}
          onPrimeMic={setMicStream}
        />

        <div className="rec-controls">
          <button className="retake-btn" onClick={retake} disabled={!inPreview || transcoding}>
            <img src="/assets/images/retake.png" alt="Retake" />
          </button>

          {!inPreview ? (
            <button
              className={`record-btn ${recording ? "recording" : ""}`}
              onPointerDown={onRecordPointerDown}
              onPointerUp={onRecordPointerUpOrCancel}
              onPointerLeave={onRecordPointerUpOrCancel}
              onContextMenu={(e) => e.preventDefault()}
              disabled={transcoding}
              aria-label="Capture / Record"
            >
              <img
                src={
                  recording
                    ? "/assets/images/record.png"
                    : arming
                    ? "/assets/images/photo-btn-alt.png"
                    : "/assets/images/photo-btn.png"
                }
                alt={arming ? "Recording…" : "Capture"}
                draggable={false}
              />
              <svg className="ring" viewBox="0 0 100 100" aria-hidden="true">
                <circle className="progress" cx="50" cy="50" r="46" />
              </svg>
            </button>
          ) : (
            <button className="record-btn" onClick={onShare} disabled={transcoding}>
              <img src="/assets/images/share-btn.png" alt="Share" />
            </button>
          )}

          {!inPreview ? (
            <button className="flip-btn" onClick={flipCamera} aria-label="Flip camera">
              <img src="/assets/images/flip_camera.png" alt="Flip" />
            </button>
          ) : (
            <div style={{ width: 48, height: 48 }} />
          )}
        </div>

        {!inPreview && (
          <>
            <img
              src="/assets/images/frame/frame1.png"
              alt=""
              aria-hidden="true"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "auto",
                pointerEvents: "none",
                zIndex: 30,
              }}
            />
            <img
              src="/assets/images/frame/frame2.png"
              alt=""
              aria-hidden="true"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "auto",
                pointerEvents: "none",
                zIndex: 30,
              }}
            />
          </>
        )}

        {videoURL && (
          <>
            <video
              ref={reviewVideoRef}
              className="review-overlay"
              src={videoURL}
              playsInline
              preload="metadata"
              poster={posterURL || undefined}
            />
            {showPlayOverlay && (
              <button className="play-btn" onClick={playWithSound}>
                <img src="/assets/images/play.png" alt="Play" />
              </button>
            )}
          </>
        )}
        {photoURL && <img className="review-overlay" src={photoURL} alt="Captured" />}

        {transcoding && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              display: "grid",
              placeItems: "center",
              zIndex: 99,
            }}
          >
            <svg width="64" height="64" viewBox="0 0 50 50" aria-label="Preparing video">
              <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke="#705fa2"
                strokeWidth="5"
                strokeLinecap="round"
                strokeDasharray="31.4 31.4"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.9s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
